import React, { FC, useMemo, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import _sortBy from 'lodash/sortBy';
import { useDrawerSearchFilterNameOrCategory, useDrawerFiltersCounts, useDrawerGlobalLoader } from '@minecraft.drawer';
import ErrorMessage from '@minecraft.error-message';
import {
  FormItem,
  useFiltersLabel,
  generateSelectOptionsBasedOnField,
  FilterDrawerType,
  FiltersNameEnum,
} from '@blocs.filter';
import { FiltersCategoryNameEnum, FiltersCountNameEnum } from '../../shared/types';
import { FacialHair } from '../../FilterDrawerCollection';
import { QUERY_FACIAL_HAIRS } from './FacialHairCategoryGraphQL';

interface Props {
  type: FilterDrawerType;
}

const FacialHairCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  const { data, error, loading } = useQuery(QUERY_FACIAL_HAIRS);

  const { isCategoryMatchedSearch, assignOptionsToCategoryFilters } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.facialHair
  );
  const { filtersCounts } = useDrawerFiltersCounts();

  const facialHairOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(
      _sortBy(data?.facialHairs, 'name'),
      'name',
      false,
      filtersCounts?.[FiltersCountNameEnum.facialHairIds]
    );
  }, [data, filtersCounts]);

  useDrawerGlobalLoader(loading);

  useEffect(() => {
    if (facialHairOptions.length > 0) {
      assignOptionsToCategoryFilters({
        [FiltersNameEnum.facialHair]: facialHairOptions,
      });
    }
  }, [facialHairOptions]);

  if (error) {
    return <ErrorMessage error={error} />;
  }

  return (
    isCategoryMatchedSearch && (
      <FormItem $fullWidth $marginValue={2}>
        <FacialHair
          willingToChange={{
            name: FiltersNameEnum.willingToFacialHair,
            label: filtersLabelOfAudience[FiltersNameEnum.willingToFacialHair],
          }}
          facialHair={{
            name: FiltersNameEnum.facialHair,
            label: filtersLabelOfAudience[FiltersNameEnum.facialHair],
          }}
        />
      </FormItem>
    )
  );
};

export default FacialHairCategory;
